// just re-using item route.
// it has a few more properties than needed, but that's ok
import editRoute from './edit';

export default editRoute.extend({});
